import { observer } from "mobx-react-lite";

import { ConfirmationModal } from "@/shared/ui";

import { useStore } from "../../model/RootStoreContext";

const ConfirmationModalProvider = observer(() => {
  const { confirmationModalStore } = useStore();

  return (
    <ConfirmationModal
      isOpen={confirmationModalStore.isOpen}
      onClose={() => confirmationModalStore.close()}
      {...confirmationModalStore.options}
    />
  );
});

export default ConfirmationModalProvider;
